import type { FC } from 'react';

import { L10nText } from '../../../../services/uiTranslations/reactBindings/L10nText';
import { Icons } from '../../../controls/iconButton/IconButton';
import { Overscrollable } from '../../../overscrollable';
import { NavDrawerButton } from '../navDrawerButton';
import type { NavDrawerHomeSlideProps } from '../types';

import navDrawerHomeSlideStyles from './navDrawerHomeSlide.module.css';

export const NavDrawerHomeSlide: FC<NavDrawerHomeSlideProps> = ({
  buttonCallbacks: {
    betLimitsClick,
    helpClick,
    historyClick,
    settingsClick,
    chatClick,
    homeClick,
    liveSupportClick,
    lobbyClick,
    quickGuideClick,
    cashierClick,
  },
  layoutConfig: { chat, home, liveSupport, lobby, quickGuide, cashier },
  isNavDrawerOpen,
  showLiveSupportReadBadge,
}) => {
  return (
    <Overscrollable scrollToTop={isNavDrawerOpen}>
      <div className={navDrawerHomeSlideStyles.navDrawerHomeSlide__grid}>
        {lobby ? null : (
          <NavDrawerButton
            data-testid="nav-drawer-lobby-button"
            icon={Icons.Grid2x2}
            onClick={lobbyClick}
            lobby
            revealed={isNavDrawerOpen}
          >
            <L10nText tk="LOBBY" />
          </NavDrawerButton>
        )}

        {cashier ? (
          <NavDrawerButton data-testid="nav-drawer-cashier-button" icon={Icons.Cashier} onClick={cashierClick}>
            <L10nText tk="CASHIER" />
          </NavDrawerButton>
        ) : null}

        {chat ? null : (
          <NavDrawerButton data-testid="nav-drawer-chat-button" icon={Icons.Chat} onClick={chatClick}>
            <L10nText tk="CHAT" />
          </NavDrawerButton>
        )}

        <NavDrawerButton data-testid="nav-drawer-history-button" icon={Icons.History} onClick={historyClick}>
          <L10nText tk="HISTORY" />
        </NavDrawerButton>

        {quickGuide ? (
          <NavDrawerButton data-testid="nav-drawer-quick-guide-button" icon={Icons.LightBulb} onClick={quickGuideClick}>
            <L10nText tk="QG_QUICK_GUIDE" />
          </NavDrawerButton>
        ) : null}

        <NavDrawerButton data-testid="nav-drawer-bet-limits-button" icon={Icons.Payouts} onClick={betLimitsClick}>
          <L10nText tk="MENU_PAYOUTS_LIMITS" />
        </NavDrawerButton>

        <NavDrawerButton data-testid="nav-drawer-settings-button" icon={Icons.Settings} onClick={settingsClick}>
          <L10nText tk="SETTINGS" />
        </NavDrawerButton>

        <NavDrawerButton data-testid="nav-drawer-help-button" icon={Icons.Help} onClick={helpClick}>
          <L10nText tk="HELP" />
        </NavDrawerButton>

        {liveSupport ? (
          <NavDrawerButton
            data-testid="nav-drawer-live-support-button"
            icon={Icons.Support}
            onClick={liveSupportClick}
            showBadge={showLiveSupportReadBadge}
          >
            <L10nText tk="MENU_SUPPORT" />
          </NavDrawerButton>
        ) : null}

        {home ? (
          <NavDrawerButton data-testid="nav-drawer-home-button" icon={Icons.Home} onClick={homeClick}>
            <L10nText tk="HOME" />
          </NavDrawerButton>
        ) : null}
      </div>
    </Overscrollable>
  );
};
